import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0fb13442"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "TTipoDeAtividades",
  "data-testid": "TTipoDeAtividades"
}
const _hoisted_2 = { class: "TTipoDeAtividades__Header" }
const _hoisted_3 = { class: "TTipoDeAtividades__Botao" }
const _hoisted_4 = { class: "TTipoDeAtividades__TabelaTiposDeAtividade" }

import { useRouter } from "vue-router"
  import { MenuItem } from "primevue/menuitem"
  import { usarPermissionamento } from "@/composable/UsarPermissionamento"
  import { OTrilhaDeNavegacao } from "@/components/Gerais"
  import { OTabelaTiposDeAtividade } from "@/components/Atividades"
  import PButton from "primevue/button"
  import { useI18n } from "vue-i18n"

  interface Props {
    breadCrumbItems: MenuItem[]
    home: MenuItem
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'TTipoDeAtividades',
  props: {
    breadCrumbItems: null,
    home: null
  },
  setup(__props: any) {

  

  const { t } = useI18n()

  const router = useRouter()
  const temPermissaoParaCriar =
    usarPermissionamento("TiposDeAtividade").verificarPermissao("criar")

  const redirecionarParaCriarTipoDeAtividade = () => {
    router.push("criar-tipo-de-atividade")
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(OTrilhaDeNavegacao), {
        "inicio-da-trilha": __props.home,
        "itens-da-trilha": __props.breadCrumbItems
      }, null, 8, ["inicio-da-trilha", "itens-da-trilha"]),
      _createElementVNode("div", _hoisted_3, [
        (_unref(temPermissaoParaCriar))
          ? (_openBlock(), _createBlock(_unref(PButton), {
              key: 0,
              onClick: redirecionarParaCriarTipoDeAtividade,
              class: "TTipoDeAtividades__Botao p-button-warning",
              "data-testid": "TTipoDeAtividades__Botao",
              label: _unref(t)('criarTipoDeAtividade')
            }, null, 8, ["label"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_unref(OTabelaTiposDeAtividade))
    ])
  ]))
}
}

})